const CONTENT_TYPE_TEMPLATE_MAP: Record<string, string> = {
  aboutpage: 't7',
  articlepage: 't5',
  contentpage: 't20',
  extendedcontentpage: 't20',
  doctorpage: 't9',
  doctorselectionpage: 't15',
  eventpage: 't10',
  globalsearchpage: 'search page',
  healthcitypage: 't2',
  homepage: 't1',
  hospital: 't3',
  hotelpage: 't21',
  internaldepartment: 't4',
  jobpage: 't20',
  lobbypage: 't8',
  locationspage: 't13',
  transparencypage: 't22'
};

export function mapContentTypeToTemplate(contentType?: string | null): string | undefined {
  if (!contentType) {
    return undefined;
  }

  const normalized = contentType.trim().toLowerCase();
  return CONTENT_TYPE_TEMPLATE_MAP[normalized] ?? contentType;
}

